import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    ApplicationState,
    CommanderThunkDispatch,
    OrderItem,
    WithServiceId,
    WithTimeUnit,
} from '@mews-commander/types';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks/services';
import { isOrderItemSelected, toggleOrderItemSelect } from '../../../../ducks/billItems';
import { isRebatedOrderItem } from '../../../../rebate/selectors/orderItems';

interface StateProps extends WithTimeUnit {
    selected: boolean;
    isRebated: boolean;
}

interface DispatchProps {
    toggleSelect(): void;
}

interface OwnProps extends WithServiceId {
    scope: string;
    orderItemId: string;
    orderItem: OrderItem;
}

export const connectOrderItemListItem = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector<ApplicationState, OwnProps, StateProps>({
        selected: isOrderItemSelected,
        // @ts-expect-error
        isRebated: (state, { orderItem }) => isRebatedOrderItem(state, { id: orderItem.id }),
        timeUnit: getTimeUnitByServiceId,
    }),
    (dispatch: CommanderThunkDispatch, { scope, orderItemId }) => ({
        toggleSelect: () => dispatch(toggleOrderItemSelect(orderItemId, scope)),
    })
);
